import { AuxiliumComponent } from "../auxilium-component";

export class ProgressItem extends AuxiliumComponent {
	constructor() {
		super();

		this.active = this.hasAttribute("active");
	}

	parsedCallback() {
		this.prepend(document.createElementWithContents("div", null, { className: "progress-item__icon" }));
	}
}